<template>
  <div class="wrap container-fluid vertical-spacing">
    <div class="row">
      <div class="col-xs">
        <SfBreadcrumbs v-if="breadcrumbs.length" :breadcrumbs="breadcrumbs" />
      </div>
    </div>
  </div>
</template>

<script>
import { SfBreadcrumbs } from '@storefront-ui/vue';
import breadcrumbs from '../../mixins/breadcrumbs';

export default {
  name: 'Breadcrumbs',
  mixins: [breadcrumbs],
  components: {
    SfBreadcrumbs,
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.sf-breadcrumbs {
  @include flexbox-mobile {
    display: none;
  }

  &/deep/ .sf-breadcrumbs__list {
    flex-wrap: wrap;
    &-item {
      padding-right: var(--spacer-xs);
      font-size: var(--font-xs);
      &::before {
        content: '';
        padding: 0;
      }
    }
    &-item:not(:last-child)::after {
      content: '>';
        padding-left: var(--spacer-xs);
    }
    .sf-breadcrumbs__breadcrumb {
      font-size: var(--font-xs);
    }
  }
}
</style>
